module.exports = __webpack_public_path__ + "img/img_49@2x.162f19e8.png";